import React from 'react';

interface TextElementProps {
  text: string;
}

export const TextElement: React.FC<TextElementProps> = ({ text }) => {
  return <p className="m-0 whitespace-pre-wrap text-[13px] leading-8 text-ds-700 app-sm:text-sm">{text}</p>;
};
